import React, { cloneElement } from 'react';
import { TopToolbar, sanitizeListRestProps, ExportButton } from 'react-admin';

const ListActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter,
  filterValues,
  permanentFilter,
  hasCreate,
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  enabledCreate,
  ...rest
}) => (
  <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
    {filters &&
      cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    {/* <ExportButton
      disabled={total === 0}
      resource={resource}
      filterValues={filterValues}
    /> */}
  </TopToolbar>
);

export default ListActions;
